/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../graphql/__generated__/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Calendar_IssuerPartsFragment = {
  __typename?: 'Issuer';
  id?: string | null;
  name?: string | null;
  cik?: string | null;
  primarySymbol?: string | null;
  sectorDisplayName?: string | null;
  customSectors?: {
    __typename?: 'CustomSectorIssuer';
    id: string;
    customSector?: { __typename?: 'CustomSector'; id: string; name?: string | null } | null;
  } | null;
};

export type Calendar_IndicationOfInterestPartsFragment = {
  __typename?: 'IndicationOfInterest';
  id: string;
  unitType?: Types.UnitType | null;
  shares?: number | null;
  dollars?: number | null;
  percentage?: number | null;
  pricingType?: Types.PricingType | null;
  limitPriceUsd?: number | null;
};

export type Calendar_OfferingAttributesPartsFragment = {
  __typename?: 'OfferingAttributes';
  status: Types.OfferingStatus;
  exchangeCountry?: Types.Country | null;
  isSpac: boolean;
  isRegS?: boolean | null;
  isRule144A?: boolean | null;
  isAccelerated?: boolean | null;
  isSecRegistered?: boolean | null;
  isConditionalLockUp?: boolean | null;
  hasMultipleLockUps?: boolean | null;
  hasCornerstoneInvestors?: boolean | null;
  launchDate?: string | null;
  lockUpExpirationDate?: string | null;
  totalBookrunners?: number | null;
  totalNonBookrunners?: number | null;
  securityTypeDisplayName?: string | null;
  price?: number | null;
  priceUsd?: number | null;
  pricingCurrency?: Types.Currency | null;
  pctFileToOffer?: number | null;
  pctToLastTrade?: number | null;
  pctOfferTo1Day?: number | null;
  pctOfferToCurrent?: number | null;
  latestPctSecondaryShares?: number | null;
  initialSizeInSecuritiesTotal?: number | null;
  latestSizeInSecuritiesTotal?: number | null;
  marketCapAtPricing?: number | null;
  marketCapAtPricingUsd?: number | null;
  pctMarketCapPreOffering?: number | null;
  latestGrossProceedsTotal?: number | null;
  latestGrossProceedsTotalUsd?: number | null;
  priceRangeLow?: number | null;
  initialIpoRangeLow?: number | null;
  initialIpoRangeLowUsd?: number | null;
  revisedIpoRangeLowUsd?: number | null;
  priceRangeHigh?: number | null;
  initialIpoRangeHighUsd?: number | null;
  revisedIpoRangeHighUsd?: number | null;
  initialIpoRangeHigh?: number | null;
  latestCouponTalkPercentageLow?: number | null;
  latestCouponTalkPercentageHigh?: number | null;
  latestPremiumTalkLowPercentage?: number | null;
  latestPremiumTalkHighPercentage?: number | null;
};

export type Calendar_UserOfferingPartsFragment = {
  __typename?: 'UserOffering';
  userId?: string | null;
  isShared: boolean;
};

export type Calendar_OfferingManagerPartsFragment = {
  __typename?: 'OfferingManager';
  name?: string | null;
  roleDisplayName?: string | null;
  isLeftLead?: boolean | null;
  managerId?: string | null;
};

export type Calendar_FirmMetricPartsFragment = {
  __typename?: 'FirmMetric';
  id: string;
  fillRate?: number | null;
};

export type Calendar_TermPartsFragment = {
  __typename?: 'Term';
  id?: string | null;
  couponPercentage?: number | null;
  premiumPercentage?: number | null;
  conversionPrice?: number | null;
};

export type Calendar_AllocationPartsFragment = {
  __typename?: 'Allocation';
  id: string;
  shares?: number | null;
  investment?: number | null;
  ioiType?: Types.IoiType | null;
  ioiTypeDisplayName?: string | null;
};

export type Calendar_OfferingPartsFragment = {
  __typename?: 'Offering';
  id: string;
  type: Types.OfferingType;
  typeDisplayName?: string | null;
  statusDisplayName?: string | null;
  symbol?: string | null;
  exchangeMic?: Types.OfferingSetupExchangeMic | null;
  exchangeRegion?: Types.Region | null;
  exchangeRegionDisplayName?: string | null;
  exchangeCountry?: Types.Country | null;
  exchangeCountryDisplayName?: string | null;
  pricingDate?: string | null;
  postponedDate?: string | null;
  firstTradeDate?: string | null;
  publicFilingDate?: string | null;
  managers: Array<{
    __typename?: 'OfferingManager';
    name?: string | null;
    roleDisplayName?: string | null;
    isLeftLead?: boolean | null;
    managerId?: string | null;
  }>;
  issuer?: {
    __typename?: 'Issuer';
    id?: string | null;
    name?: string | null;
    cik?: string | null;
    primarySymbol?: string | null;
    sectorDisplayName?: string | null;
    customSectors?: {
      __typename?: 'CustomSectorIssuer';
      id: string;
      customSector?: { __typename?: 'CustomSector'; id: string; name?: string | null } | null;
    } | null;
  } | null;
  indicationsOfInterest?: Array<{
    __typename?: 'IndicationOfInterest';
    id: string;
    unitType?: Types.UnitType | null;
    shares?: number | null;
    dollars?: number | null;
    percentage?: number | null;
    pricingType?: Types.PricingType | null;
    limitPriceUsd?: number | null;
  }> | null;
  attributes?: {
    __typename?: 'OfferingAttributes';
    status: Types.OfferingStatus;
    exchangeCountry?: Types.Country | null;
    isSpac: boolean;
    isRegS?: boolean | null;
    isRule144A?: boolean | null;
    isAccelerated?: boolean | null;
    isSecRegistered?: boolean | null;
    isConditionalLockUp?: boolean | null;
    hasMultipleLockUps?: boolean | null;
    hasCornerstoneInvestors?: boolean | null;
    launchDate?: string | null;
    lockUpExpirationDate?: string | null;
    totalBookrunners?: number | null;
    totalNonBookrunners?: number | null;
    securityTypeDisplayName?: string | null;
    price?: number | null;
    priceUsd?: number | null;
    pricingCurrency?: Types.Currency | null;
    pctFileToOffer?: number | null;
    pctToLastTrade?: number | null;
    pctOfferTo1Day?: number | null;
    pctOfferToCurrent?: number | null;
    latestPctSecondaryShares?: number | null;
    initialSizeInSecuritiesTotal?: number | null;
    latestSizeInSecuritiesTotal?: number | null;
    marketCapAtPricing?: number | null;
    marketCapAtPricingUsd?: number | null;
    pctMarketCapPreOffering?: number | null;
    latestGrossProceedsTotal?: number | null;
    latestGrossProceedsTotalUsd?: number | null;
    priceRangeLow?: number | null;
    initialIpoRangeLow?: number | null;
    initialIpoRangeLowUsd?: number | null;
    revisedIpoRangeLowUsd?: number | null;
    priceRangeHigh?: number | null;
    initialIpoRangeHighUsd?: number | null;
    revisedIpoRangeHighUsd?: number | null;
    initialIpoRangeHigh?: number | null;
    latestCouponTalkPercentageLow?: number | null;
    latestCouponTalkPercentageHigh?: number | null;
    latestPremiumTalkLowPercentage?: number | null;
    latestPremiumTalkHighPercentage?: number | null;
  } | null;
  firmMetric?: { __typename?: 'FirmMetric'; id: string; fillRate?: number | null } | null;
  lastAllocation?: {
    __typename?: 'Allocation';
    id: string;
    shares?: number | null;
    investment?: number | null;
    ioiType?: Types.IoiType | null;
    ioiTypeDisplayName?: string | null;
  } | null;
  finalTerm?: {
    __typename?: 'Term';
    id?: string | null;
    couponPercentage?: number | null;
    premiumPercentage?: number | null;
    conversionPrice?: number | null;
  } | null;
  userOfferings?: Array<{
    __typename?: 'UserOffering';
    userId?: string | null;
    isShared: boolean;
  } | null> | null;
  offeringNotes?: Array<{ __typename?: 'OfferingNote'; note?: string | null } | null> | null;
  ioiNotes?: Array<{ __typename?: 'IoiNote'; note?: string | null }> | null;
};

export type Calendar_GridRowDataQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  where?: Types.InputMaybe<Types.OfferingFilterInput>;
  order?: Types.InputMaybe<Array<Types.OfferingSortInput> | Types.OfferingSortInput>;
  hasIoiPermission: Types.Scalars['Boolean'];
  hasCustomSectorsPermission: Types.Scalars['Boolean'];
}>;

export type Calendar_GridRowDataQuery = {
  __typename?: 'Query';
  offerings?: {
    __typename?: 'OfferingCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Offering';
      id: string;
      type: Types.OfferingType;
      typeDisplayName?: string | null;
      statusDisplayName?: string | null;
      symbol?: string | null;
      exchangeMic?: Types.OfferingSetupExchangeMic | null;
      exchangeRegion?: Types.Region | null;
      exchangeRegionDisplayName?: string | null;
      exchangeCountry?: Types.Country | null;
      exchangeCountryDisplayName?: string | null;
      pricingDate?: string | null;
      postponedDate?: string | null;
      firstTradeDate?: string | null;
      publicFilingDate?: string | null;
      managers: Array<{
        __typename?: 'OfferingManager';
        name?: string | null;
        roleDisplayName?: string | null;
        isLeftLead?: boolean | null;
        managerId?: string | null;
      }>;
      issuer?: {
        __typename?: 'Issuer';
        id?: string | null;
        name?: string | null;
        cik?: string | null;
        primarySymbol?: string | null;
        sectorDisplayName?: string | null;
        customSectors?: {
          __typename?: 'CustomSectorIssuer';
          id: string;
          customSector?: { __typename?: 'CustomSector'; id: string; name?: string | null } | null;
        } | null;
      } | null;
      indicationsOfInterest?: Array<{
        __typename?: 'IndicationOfInterest';
        id: string;
        unitType?: Types.UnitType | null;
        shares?: number | null;
        dollars?: number | null;
        percentage?: number | null;
        pricingType?: Types.PricingType | null;
        limitPriceUsd?: number | null;
      }> | null;
      attributes?: {
        __typename?: 'OfferingAttributes';
        status: Types.OfferingStatus;
        exchangeCountry?: Types.Country | null;
        isSpac: boolean;
        isRegS?: boolean | null;
        isRule144A?: boolean | null;
        isAccelerated?: boolean | null;
        isSecRegistered?: boolean | null;
        isConditionalLockUp?: boolean | null;
        hasMultipleLockUps?: boolean | null;
        hasCornerstoneInvestors?: boolean | null;
        launchDate?: string | null;
        lockUpExpirationDate?: string | null;
        totalBookrunners?: number | null;
        totalNonBookrunners?: number | null;
        securityTypeDisplayName?: string | null;
        price?: number | null;
        priceUsd?: number | null;
        pricingCurrency?: Types.Currency | null;
        pctFileToOffer?: number | null;
        pctToLastTrade?: number | null;
        pctOfferTo1Day?: number | null;
        pctOfferToCurrent?: number | null;
        latestPctSecondaryShares?: number | null;
        initialSizeInSecuritiesTotal?: number | null;
        latestSizeInSecuritiesTotal?: number | null;
        marketCapAtPricing?: number | null;
        marketCapAtPricingUsd?: number | null;
        pctMarketCapPreOffering?: number | null;
        latestGrossProceedsTotal?: number | null;
        latestGrossProceedsTotalUsd?: number | null;
        priceRangeLow?: number | null;
        initialIpoRangeLow?: number | null;
        initialIpoRangeLowUsd?: number | null;
        revisedIpoRangeLowUsd?: number | null;
        priceRangeHigh?: number | null;
        initialIpoRangeHighUsd?: number | null;
        revisedIpoRangeHighUsd?: number | null;
        initialIpoRangeHigh?: number | null;
        latestCouponTalkPercentageLow?: number | null;
        latestCouponTalkPercentageHigh?: number | null;
        latestPremiumTalkLowPercentage?: number | null;
        latestPremiumTalkHighPercentage?: number | null;
      } | null;
      firmMetric?: { __typename?: 'FirmMetric'; id: string; fillRate?: number | null } | null;
      lastAllocation?: {
        __typename?: 'Allocation';
        id: string;
        shares?: number | null;
        investment?: number | null;
        ioiType?: Types.IoiType | null;
        ioiTypeDisplayName?: string | null;
      } | null;
      finalTerm?: {
        __typename?: 'Term';
        id?: string | null;
        couponPercentage?: number | null;
        premiumPercentage?: number | null;
        conversionPrice?: number | null;
      } | null;
      userOfferings?: Array<{
        __typename?: 'UserOffering';
        userId?: string | null;
        isShared: boolean;
      } | null> | null;
      offeringNotes?: Array<{ __typename?: 'OfferingNote'; note?: string | null } | null> | null;
      ioiNotes?: Array<{ __typename?: 'IoiNote'; note?: string | null }> | null;
    }> | null;
    pageInfo: {
      __typename?: 'CollectionSegmentInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      pageSize: number;
    };
  } | null;
};

export const Calendar_OfferingManagerPartsFragmentDoc = gql`
  fragment Calendar_OfferingManagerParts on OfferingManager {
    name
    roleDisplayName
    isLeftLead
    managerId
  }
`;
export const Calendar_IssuerPartsFragmentDoc = gql`
  fragment Calendar_IssuerParts on Issuer {
    id
    name
    cik
    primarySymbol
    sectorDisplayName
    customSectors @include(if: $hasCustomSectorsPermission) {
      id
      customSector {
        id
        name
      }
    }
  }
`;
export const Calendar_IndicationOfInterestPartsFragmentDoc = gql`
  fragment Calendar_IndicationOfInterestParts on IndicationOfInterest {
    id
    unitType
    shares
    dollars
    percentage
    pricingType
    limitPriceUsd
  }
`;
export const Calendar_OfferingAttributesPartsFragmentDoc = gql`
  fragment Calendar_OfferingAttributesParts on OfferingAttributes {
    status
    exchangeCountry
    isSpac
    isRegS
    isRule144A
    isAccelerated
    isSecRegistered
    isConditionalLockUp
    hasMultipleLockUps
    hasCornerstoneInvestors
    launchDate
    lockUpExpirationDate
    totalBookrunners
    totalNonBookrunners
    securityTypeDisplayName
    price
    priceUsd
    pricingCurrency
    pctFileToOffer
    pctToLastTrade
    pctOfferTo1Day
    pctOfferToCurrent
    latestPctSecondaryShares
    initialSizeInSecuritiesTotal
    latestSizeInSecuritiesTotal
    marketCapAtPricing
    marketCapAtPricingUsd
    pctMarketCapPreOffering
    latestGrossProceedsTotal
    latestGrossProceedsTotalUsd
    priceRangeLow
    initialIpoRangeLow
    initialIpoRangeLowUsd
    revisedIpoRangeLowUsd
    priceRangeHigh
    initialIpoRangeHighUsd
    revisedIpoRangeHighUsd
    initialIpoRangeHigh
    latestCouponTalkPercentageLow
    latestCouponTalkPercentageHigh
    latestPremiumTalkLowPercentage
    latestPremiumTalkHighPercentage
  }
`;
export const Calendar_FirmMetricPartsFragmentDoc = gql`
  fragment Calendar_FirmMetricParts on FirmMetric {
    id
    fillRate
  }
`;
export const Calendar_AllocationPartsFragmentDoc = gql`
  fragment Calendar_AllocationParts on Allocation {
    id
    shares
    investment
    ioiType
    ioiTypeDisplayName
  }
`;
export const Calendar_TermPartsFragmentDoc = gql`
  fragment Calendar_TermParts on Term {
    id
    couponPercentage
    premiumPercentage
    conversionPrice
  }
`;
export const Calendar_UserOfferingPartsFragmentDoc = gql`
  fragment Calendar_UserOfferingParts on UserOffering {
    userId
    isShared
  }
`;
export const Calendar_OfferingPartsFragmentDoc = gql`
  fragment Calendar_OfferingParts on Offering {
    id
    type
    typeDisplayName
    statusDisplayName
    symbol
    exchangeMic
    exchangeRegion
    exchangeRegionDisplayName
    exchangeCountry
    exchangeCountryDisplayName
    pricingDate
    postponedDate
    firstTradeDate
    publicFilingDate
    managers {
      ...Calendar_OfferingManagerParts
    }
    issuer {
      ...Calendar_IssuerParts
    }
    indicationsOfInterest @include(if: $hasIoiPermission) {
      ...Calendar_IndicationOfInterestParts
    }
    attributes {
      ...Calendar_OfferingAttributesParts
    }
    firmMetric @include(if: $hasIoiPermission) {
      ...Calendar_FirmMetricParts
    }
    lastAllocation @include(if: $hasIoiPermission) {
      ...Calendar_AllocationParts
    }
    finalTerm {
      ...Calendar_TermParts
    }
    userOfferings {
      ...Calendar_UserOfferingParts
    }
    offeringNotes {
      note
    }
    ioiNotes @include(if: $hasIoiPermission) {
      note
    }
  }
  ${Calendar_OfferingManagerPartsFragmentDoc}
  ${Calendar_IssuerPartsFragmentDoc}
  ${Calendar_IndicationOfInterestPartsFragmentDoc}
  ${Calendar_OfferingAttributesPartsFragmentDoc}
  ${Calendar_FirmMetricPartsFragmentDoc}
  ${Calendar_AllocationPartsFragmentDoc}
  ${Calendar_TermPartsFragmentDoc}
  ${Calendar_UserOfferingPartsFragmentDoc}
`;
export const Calendar_GridRowDataDocument = gql`
  query Calendar_GridRowData(
    $skip: Int
    $take: Int
    $where: OfferingFilterInput
    $order: [OfferingSortInput!]
    $hasIoiPermission: Boolean!
    $hasCustomSectorsPermission: Boolean!
  ) {
    offerings(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        ...Calendar_OfferingParts
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        pageSize
      }
      totalCount
    }
  }
  ${Calendar_OfferingPartsFragmentDoc}
`;

/**
 * __useCalendar_GridRowDataQuery__
 *
 * To run a query within a React component, call `useCalendar_GridRowDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendar_GridRowDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendar_GridRowDataQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      hasIoiPermission: // value for 'hasIoiPermission'
 *      hasCustomSectorsPermission: // value for 'hasCustomSectorsPermission'
 *   },
 * });
 */
export function useCalendar_GridRowDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Calendar_GridRowDataQuery,
    Calendar_GridRowDataQueryVariables
  > &
    ({ variables: Calendar_GridRowDataQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Calendar_GridRowDataQuery, Calendar_GridRowDataQueryVariables>(
    Calendar_GridRowDataDocument,
    options
  );
}
export function useCalendar_GridRowDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Calendar_GridRowDataQuery,
    Calendar_GridRowDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Calendar_GridRowDataQuery, Calendar_GridRowDataQueryVariables>(
    Calendar_GridRowDataDocument,
    options
  );
}
export function useCalendar_GridRowDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Calendar_GridRowDataQuery, Calendar_GridRowDataQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Calendar_GridRowDataQuery, Calendar_GridRowDataQueryVariables>(
    Calendar_GridRowDataDocument,
    options
  );
}
export type Calendar_GridRowDataQueryHookResult = ReturnType<typeof useCalendar_GridRowDataQuery>;
export type Calendar_GridRowDataLazyQueryHookResult = ReturnType<
  typeof useCalendar_GridRowDataLazyQuery
>;
export type Calendar_GridRowDataSuspenseQueryHookResult = ReturnType<
  typeof useCalendar_GridRowDataSuspenseQuery
>;
export type Calendar_GridRowDataQueryResult = Apollo.QueryResult<
  Calendar_GridRowDataQuery,
  Calendar_GridRowDataQueryVariables
>;
